import React from "react";

import {Route, Switch} from "react-router-dom";

// General:
import Login from "../auth/Login/Login";
import {Alert, ReduxProtectedRoute} from "@leap4/frontend";
import {requiredAuthRoles, BACKEND_SERVICE_NAME} from "../../config/generals";
import {urlService} from "./urlsService";



//todo: add here organization page

//  Modules:
import OrganizationsPage from "../organizations/OrganizationsModule"
import UsersPage from "../users/UsersModule"
import OwnershipsPage from "../ownerships/OwnershipsModule"
import PublisherLoginPage from "../publisherLogins/PublisherLoginsModule"
import {editOrganization} from "../organizations/Organization/edit/EditOrganization";
import {editPublisherLogins} from "../publisherLogins/PublisherLogin/edit/EditPublisherLogins";
import {editUser} from "../users/User/edit/EditUser";
import {AddUser} from "../users/AddEditUser/AddUser";
import {addOrganization} from "../organizations/Organization/add/addOrganization";
import {addOwnership} from "../ownerships/Ownership/add/addOwnership";

const Routes = () => {

    return (
        <section className="container">
            <Alert/>
            <Switch>
                <Route exact path="/login" component={Login}/>

                {/************** Organizations *************/}
                <ReduxProtectedRoute exact={true} backendServiceName={BACKEND_SERVICE_NAME}
                                     requiredRoles={requiredAuthRoles}
                                     component={OrganizationsPage} path={urlService.organizations()}/>
                <ReduxProtectedRoute exact={false} backendServiceName={BACKEND_SERVICE_NAME}
                                     requiredRoles={requiredAuthRoles}
                                     component={editOrganization} path={urlService.editOrganization()}/>

                <ReduxProtectedRoute exact={true} backendServiceName={BACKEND_SERVICE_NAME}
                                     requiredRoles={requiredAuthRoles}
                                     component={PublisherLoginPage} path={urlService.publisherLogins()}/>
                <ReduxProtectedRoute exact={false} backendServiceName={BACKEND_SERVICE_NAME}
                                     requiredRoles={requiredAuthRoles}
                                     component={editPublisherLogins} path={urlService.editPublisherLogins()}/>

                <ReduxProtectedRoute exact={true} backendServiceName={BACKEND_SERVICE_NAME}
                                     requiredRoles={requiredAuthRoles}
                                     component={UsersPage} path={urlService.users()}/>
                <ReduxProtectedRoute exact={false} backendServiceName={BACKEND_SERVICE_NAME}
                                     requiredRoles={requiredAuthRoles}
                                     component={editUser} path={urlService.editUsers()}/>

                <ReduxProtectedRoute exact={true} backendServiceName={BACKEND_SERVICE_NAME}
                                     requiredRoles={requiredAuthRoles}
                                     component={AddUser} path={urlService.addUser()}/>

                <ReduxProtectedRoute exact={true} backendServiceName={BACKEND_SERVICE_NAME}
                                     requiredRoles={requiredAuthRoles}
                                     component={addOrganization} path={urlService.addOrganization()}/>

                <ReduxProtectedRoute exact={true} backendServiceName={BACKEND_SERVICE_NAME}
                                     requiredRoles={requiredAuthRoles}
                                     component={OwnershipsPage} path={urlService.ownerships()}/>
                <ReduxProtectedRoute exact={true} backendServiceName={BACKEND_SERVICE_NAME}
                                     requiredRoles={requiredAuthRoles}
                                     component={addOwnership} path={urlService.createOwnerships()}/>


                <Route component={Login}/>
            </Switch>
        </section>
    )
};

export default Routes;
